export default function validation(response, messages) {
  if (!response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    const numLigne = message.split('__');
    let preMessage = null;
    if (numLigne[1]) {
      preMessage = { message: 'importDonne.numLigne', parametres: { num: numLigne[1] } };
    }
    if (message.indexOf('The field Nom ') !== -1) {
      messages.push({ message: 'addEditBailleur.error.nom', preMessage });
    }
    if (message.indexOf('ONLY_ONE_LESSOR_TYPE') === 0) {
      messages.push({
        message: 'editionFournisseur.errors.pasMultiBailleur',
      });
    }
    if (message.indexOf('TIER_ALREADY_USE_IN_AN_ELEMENT') === 0) {
      messages.push({
        message: 'editionFournisseur.errors.utiliseDansAffixe',
      });
    }
  });
}
